import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62624881"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "event-tile-container"
}
const _hoisted_2 = { class: "event-img-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "event-name" }
const _hoisted_5 = { class: "event-date" }
const _hoisted_6 = {
  key: 1,
  class: "selected-event-tile-container"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "selected-event__details-column selected-event__column" }
const _hoisted_9 = { class: "selected-event-name" }
const _hoisted_10 = { class: "selected-event-website-text" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "event-date" }
const _hoisted_13 = { class: "event-date selected-event-socials" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Socials:", -1))
const _hoisted_15 = { class: "event-attendance" }
const _hoisted_16 = {
  key: 0,
  class: "selected-event-attendees selected-event__column"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "selected-event-attendees-title" }, " Who is going? ", -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "selected-event-attendees selected-event__details-column selected-event__column"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "selected-event-attendees-title" }, " Want to represent PWN? ", -1))
const _hoisted_21 = { class: "selected-event-attendees-subtitle" }

import { computed, toRefs } from 'vue'
import { CryptoEvent } from '@/components/Events/events'
import useEvents from '@/components/Events/useEvents'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventTile',
  props: {
    event: null,
    selected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  event: CryptoEvent,
  selected: boolean
};



const { event, selected } = toRefs(props)

const attendanceStatus = computed(() => event.value.isAttending ? 'Going' : 'Not going')
const eventImageUrl = computed(() => `https:${event.value.eventLogo.fields.file.url}`)

const { selectedEvent } = useEvents()

const handleTwitterUserClick = (representative: string) => {
  window.open(`https://twitter.com/${representative}`, '_blank')
}

const handleSocialMediaClick = (url: string) => {
  window.open(url, '_blank')
}

const openEmail = () => {
  window.location.href = 'mailto:contact@pwn.xyz?subject=Representing%20PWN%20at%20Events'
}

const closeEvent = () => {
  selectedEvent.value = -1
}

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_unref(event))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["event-tile-wrapper", {selected: _unref(selected)}])
      }, [
        (!_unref(selected))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  class: "event__img",
                  src: _unref(eventImageUrl)
                }, null, 8, _hoisted_3)
              ]),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(event).name), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(event).date), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["event-attendance-status", {attending: _unref(event).isAttending}])
              }, _toDisplayString(_unref(attendanceStatus)), 3)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "selected-event__column",
                onMousedown: closeEvent
              }, [
                _createElementVNode("img", {
                  class: "selected-event__img",
                  src: _unref(eventImageUrl)
                }, null, 8, _hoisted_7)
              ], 32),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(event).name), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(" Website: "),
                  _createElementVNode("a", {
                    class: "website",
                    href: _unref(event).websiteUrl,
                    target: "_blank"
                  }, _toDisplayString(_unref(event).websiteUrl.substring(8)), 9, _hoisted_11)
                ]),
                _createElementVNode("div", _hoisted_12, " Date: " + _toDisplayString(_unref(event).date), 1),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", null, [
                    (_unref(event).twitterUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "selected-event__img-socials",
                          src: "/twitter.svg",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSocialMediaClick(_unref(event).twitterUrl ?? '')))
                        }))
                      : _createCommentVNode("", true),
                    (_unref(event).discordUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "selected-event__img-socials",
                          src: "/discord.svg",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSocialMediaClick(_unref(event).discordUrl ?? '')))
                        }))
                      : _createCommentVNode("", true),
                    (_unref(event).telegramUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 2,
                          class: "selected-event__img-socials",
                          src: "/telegram.svg",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSocialMediaClick(_unref(event).telegramUrl ?? '')))
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createTextVNode(" Attendance: "),
                  _createElementVNode("span", {
                    class: _normalizeClass(["event-attendance-status", {attending: _unref(event).isAttending}])
                  }, _toDisplayString(_unref(attendanceStatus)), 3)
                ])
              ]),
              (_unref(event).representatives)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _hoisted_17,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(event).representatives, (rep, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "selected-event-attendee-name",
                        onClick: ($event: any) => (handleTwitterUserClick(rep))
                      }, " @" + _toDisplayString(rep), 9, _hoisted_18))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (!_unref(event).representatives)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createTextVNode(" (what does it mean?) ")
                    ])), [
                      [_directive_tooltip, {content:'<div>1) Establish partnerships with valuable players in the industry</div><br/><div>2) Ensure PWN presence at every conference / meetup / event</div><br/><div>Find out more information by contacting us</div>', theme: 'info-tooltip', html: true}]
                    ]),
                    _createElementVNode("div", {
                      class: "primary-btn selected-event__btn",
                      onClick: openEmail
                    }, " Contact Us ")
                  ]))
                : _createCommentVNode("", true)
            ]))
      ], 2))
    : _createCommentVNode("", true)
}
}

})